<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información de la Chequera">
          <b-form>
            <app-banco-cuenta
              label="Cuenta"
              :nombre= 'bancoCuentaNombre'
              :lista= 'bancosCuentasList'
              :labelCols= 'labelCols'
              :valido="bancoCuentaValida"
              :msjInvalido="bancoCuentaInvalidaMsj"
              @updated="bancoCuentaActualizada">
            </app-banco-cuenta>

            <b-form-group
              label="Nro. Inicial"
              label-for="numeroInicial"
              :label-cols= 'labelCols'
              horizontal>
              <b-form-input 
                id="numeroInicial"
                v-model.trim= "$v.numeroInicial.$model" 
                :state="numeroInicialValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroInicialFeedback">
                {{ numeroInicialInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nro. Final"
              label-for="numeroFinal"
              :label-cols= 'labelCols'
              horizontal>
              <b-form-input 
                id="numeroFinal"
                v-model.trim= "$v.numeroFinal.$model" 
                :state="numeroFinalValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroFinalFeedback">
                {{ numeroFinalInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="SGC" 
        v-model="modalMsj" 
        header-bg-variant="light"
        ok-only 
        ok-variant="primary footer-button"
        @ok='okAction' @hidden="hiddenAction">
      {{ modalMensaje }}
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  
  </div>
</template>

<script>
import BancoCuenta from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import { required, requiredIf, numeric, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancochequera/getField',
  mutationType: 'bancochequera/updateField',
});

export default {
  name: 'BancoChequera',
  components: {
    appBancoCuenta: BancoCuenta,
    appABMButton: ABMButtons
  },
  data () {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,

      noValidar: true,
      bancoCuentaValida: null,
      bancoCuentaInvalidaMsj: '',
      numeroInicialValido: null,
      numeroInicialInvalidoMsj: '',
      numeroFinalValido: null,
      numeroFinalInvalidoMsj: '',

      bancosCuentas: [],
      bancosCuentasList: [],

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'id',
      'bancoCuenta',
      'bancoCuentaNombre',
      'numeroInicial',
      'numeroFinal',
    ])
  },  
  created() {
    let bancoChequeraId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        bancoChequeraId = this.$route.params.id;
      }
    }

    this.procesando();
    this.$store.dispatch('bancochequera/inicializar', bancoChequeraId)
      .then(() => {
        this.getDatosAdicionales();
      })
      .catch(error => {
        this.modalOkAction = null;
        this.modalHiddenAction = null;
        this.modalMensaje = "Se produjo un error al recuperar la información de la chequera."
        this.modalMsj = true;
      })
      .finally(() => {
        this.procesando();
      })
  },  
  methods: {
    okAction(){
      if (this.modalOkAction) {
        this.modalOkAction();
      }
    },
    hiddenAction(){
      if (this.modalHiddenAction) {
        this.modalHiddenAction();
      }
    },
    getDatosAdicionales() {
      const vm = this

      this.$store.dispatch('bancoscuentas/getList')
        .then(() => {
            vm.bancosCuentas = this.$store.getters['bancoscuentas/list']
            vm.bancosCuentasList = this.$store.getters['bancoscuentas/selectList']
          })
          .catch(error => {
            if (!modal) {
              this.modalOkAction = null;
              this.modalHiddenAction = null;
              this.modalMensaje = "Se produjo un error al recuperar la información de cuentas bancarias.";
              this.modalMsj = true;
            } else {
              this.alertMsj = "Se produjo un error al recuperar la información de cuentas bancarias.";
              this.alertVariant = "danger";
              this.alertCountDown = 15;
              this.showAlert();              
            }
          })
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'numeroInicial' || validarTodos) {
        if (this.$v.numeroInicial.$error) {
          this.numeroInicialValido = false;
          if (!this.$v.numeroInicial.required) {
            this.numeroInicialInvalidoMsj = 'Debe ingresar el número inicial de la chequera.';
          } else if (!this.$v.numeroInicial.numeric || !this.$v.numeroInicial.minValue) {
            this.numeroInicialInvalidoMsj = 'El número inicial de la chequera ingresado no es válido.';
          }      
        } else {
          this.numeroInicialValido = null;
          this.numeroInicialInvalidoMsj = '';
        }
      }

      if (campo == 'numeroFinal' || validarTodos) {
        if (this.$v.numeroFinal.$error) {
          this.numeroFinalValido = false;
          if (!this.$v.numeroFinal.required) {
            this.numeroFinalInvalidoMsj = 'Debe ingresar el número final de la chequera.';
          } else if (!this.$v.numeroFinal.numeric || !this.$v.numeroFinal.minValue) {
            this.numeroFinalInvalidoMsj = 'El número final de la chequera ingresado no es válido.';
          }      
        } else {
          this.numeroFinalValido = null;
          this.numeroFinalInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      let bancoCuenta = null;
      if (this.bancoCuentaNombre) {
        bancoCuenta = this.getSelected(this.bancosCuentas, this.bancoCuentaNombre);
      }
      this.$store.dispatch('bancochequera/setBancoCuenta', bancoCuenta);

      let bancoCuentaError = true;
      if (this.bancoCuenta) {
        if (this.bancoCuenta.id) {
          if (this.bancoCuenta.id != 0) {
            bancoCuentaError = false;
          }
        }
      }
      if (bancoCuentaError) {
        save = false;
        this.bancoCuentaValida = false;
        this.bancoCuentaInvalidaMsj = "Debe seleccionar la cuenta correspondiente.";
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('bancochequera/save')
            .then(() => {
              this.modalOkAction = this.goList;
              this.modalHiddenAction = this.goList;
              this.modalMensaje = "Los cambios se registraron con éxito.";
              this.modalMsj = true;
            })
            .catch( error => {
              this.modalOkAction = null;
              this.modalHiddenAction = null;
              this.modalMensaje = error.errorMessage;
              this.modalMsj = true;
            })
            .finally(() => {
              this.hideSpinner();
            })
        }
      } 
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ name: "BancosChequeras" });
    },
    bancoCuentaActualizada(bancoCuentaNombre) {
      this.bancoCuentaNombre = bancoCuentaNombre;
      this.bancoCuentaValida = null;
      this.bancoCuentaInvalidaMsj = '';
    },
  },
  watch: {
  },
  validations: {
    numeroInicial: {
      required, 
      numeric,
      minValue: minValue(1)
    },
    numeroFinal: {
      required, 
      numeric,
      minValue: minValue(1)
    },
  },  
}
</script>

<style>
</style>
